import { FormControl } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FormTemplateTypeEnum } from "../../_common/enum/forms/fomTemplateType.enum";
import config from "../../_config/config.const";
import { handleErrorResponse } from "../../_helpers/handleResponse.helper";
import { formService } from "../../_services/form.service";

export function Forms() {
    const navigate = useNavigate();

    const [isLoading, setLoading] = useState(false);
    const [formTypeId, setFormTypeId] = useState<FormTemplateTypeEnum | null>(null);

    useEffect(() => {
        createNewForm(FormTemplateTypeEnum.Booking);
    }, []);

    function createNewForm(formTypeId: FormTemplateTypeEnum) {
        setLoading(true);
        return formService
            .createByType(formTypeId)
            .then(
                (publicId: string) => {
                    navigate(`${publicId}`);
                },
                handleErrorResponse
            )
            .finally(() => setLoading(false));
    }

    return (
        <div aria-busy={isLoading || undefined}>
            <FormControl fullWidth variant="outlined">
            </FormControl>
        </div>
    );
}

export default Forms;



